import React, {Component} from 'react';
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';

import Landing from './pages/Landing';
import Support from './pages/Support';
import Privacy from './pages/Privacy';

class App extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/support" component={Support} />
          <Route exact path="/privacy" component={Privacy} />
          <Route component={Landing} />
        </Switch>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js